/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Minimal plugin metadata for distributing an authorized skill. Does not expose configuration or assignments.
 */
export type DistributionPlugin = {
  /**
   * Whether automatic role distribution created this plugin. Read-only; preserved after edits and reuse.
   */
  autoCreated: boolean;
  description?: string | undefined;
  id: string;
  isDefault: boolean;
  name: string;
};

/** @internal */
export const DistributionPlugin$inboundSchema: z.ZodMiniType<
  DistributionPlugin,
  unknown
> = z.pipe(
  z.object({
    auto_created: z.boolean(),
    description: z.optional(z.string()),
    id: z.string(),
    is_default: z.boolean(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "auto_created": "autoCreated",
      "is_default": "isDefault",
    });
  }),
);

export function distributionPluginFromJSON(
  jsonString: string,
): SafeParseResult<DistributionPlugin, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DistributionPlugin$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DistributionPlugin' from JSON`,
  );
}
